// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3O8sy-IXMiPL2cCVatJ2T1","top":"_1tt3QgOCqoMdl0rFVTQRdU"};